export const Fruit: BaseRecord[] = [
  { label: '🍇  Grapes', value: 'grapes' },
  { label: '🍈  Melon', value: 'melon' },
  { label: '🍉  Watermelon', value: 'watermelon' },
  { label: '🍊  Tangerine', value: 'tangerine' },
  { label: '🍋  Lemon', value: 'lemon' },
  { label: '🍌  Banana', value: 'banana' },
  { label: '🍍  Pineapple', value: 'pineapple' },
  { label: '🍎  Apple', value: 'apple' },
  { label: '🍏  Green apple', value: 'green apple' },
  { label: '🍐  Pear', value: 'pear' },
  { label: '🍑  Peach', value: 'peach' },
  { label: '🍒  Cherries', value: 'cherries' },
  { label: '🍓  Strawberry', value: 'strawberry' },
  { label: '🍅  Tomato', value: 'tomato' },
  { label: '🥥  Coconut', value: 'coconut' }
]
